import { render, staticRenderFns } from "./AdditionalSave.vue?vue&type=template&id=fb7fa34e&"
import script from "./AdditionalSave.vue?vue&type=script&lang=js&"
export * from "./AdditionalSave.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSave.vue?vue&type=style&index=0&id=fb7fa34e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports